import TaxCalculator from 'TaxCalculator';
import TaxReformGuideMap from 'UsaMap/containers/TaxReformGuideMap';
import TaxGraph from 'TaxGraph';
import TaxFlowChart from 'TaxFlowChart';

window.TaxCalculator = TaxCalculator;
window.TaxReformGuideMap = TaxReformGuideMap;
window.TaxGraph = TaxGraph;
window.TaxFlowChart = TaxFlowChart;



// WEBPACK FOOTER //
// ./src-assets/js/tax-guide.js